import { Button } from "@/components/ui/button";

interface UnitReserveButtonProps {
    className?: string;
    label?: string;
    onReservationClick: () => void;
}

export const ReserveButton = ({
    className = "reserve-btn",
    label = "Reserve",
    onReservationClick,
}: UnitReserveButtonProps) => {
    return (
        <Button
            variant="secondary"
            data-testid="reserveButton"
            onClick={onReservationClick}
            className={className}
            aria-label={label}
            type="button"
        >
            {label}
        </Button>
    );
};

ReserveButton.displayName = "ReserveButton";
